export default "__VITE_ASSET__BcN55VQ$__"